<lyceo-content [background]="true">
  <lyceo-spinner
    class="spinner"
    [imageSrc]="imageSrc()"
    [size]="SpinnerSize.LARGE"
  />
</lyceo-content>
